import { render, staticRenderFns } from "./HotelInfo.vue?vue&type=template&id=a99bb17c&"
import script from "./HotelInfo.vue?vue&type=script&lang=js&"
export * from "./HotelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports